
export default function meetings( state = [], action = {} ){

	switch( action.type ){
		case 'GET_MEETINGS':
			return action.meetings
		case 'SAVE_MEETINGS':
			return action.meetings
		case 'DELETE_MEETINGS':
			return action.meetings
		case 'GET_MEETINGS_BY_ID':
			return action.meetings
		case 'UPDATE_MEETINGS':
			return action.meetings
		default: return state;
	}
		
}


// WEBPACK FOOTER //
// ./src/store/reducers/meetings/meetings.reducer.js